<template>
  <div id="ProductDetail" class="product-detail flex-item flex-item-grow flex-container flex-row">
    <gjw-dimensions @height-changed="getMainHeight">
      <div class="page-left">
        <div class="page-left-wrapper" :style="{'margin-right':showPrice?'1rem':'0'}">
          <div class="header flex-container flex-row" :style="{'padding-top':platform==='web'?'10px':'0'}">
            <div class="header-left" :style="{width: `${headerRightHeight}px`, height:`${headerRightHeight}px`}">
              <div class="img-tab-container flex-container flex-row flex-horiz-center">
                <img class="product-img" :src="productImage" alt="" @error="imageUrlFailed= true">
              </div>
            </div>
            <gjw-dimensions @height-changed="getHeaderRightHeight">
              <div class="header-right">
                <div class="flex-container flex-row flex-verti-bottom">
                  <div class="header-right-info">
                    <h1 class="model">{{detail.model||'型号'}}</h1>
                    <div class="flex-container flex-row">
                      <div class="meta">
                        <span class="name">品牌：</span>
                        <span class="value">{{detail.brandName}}</span>
                      </div>
                      <div class="meta">
                        <span class="name">所属系列：</span>
                        <span class="value">{{detail.productSeriesName}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="header-right-button">
                    <el-button plain @click="detailToFeedback">联系厂家</el-button>
                    <el-button
                        v-if="platform!=='r'"
                        plain
                        :disabled="pageLoading"
                        @click="getPrice">价格查询</el-button>
                  </div>
                </div>
                <source-list
                    :show-place-button="false"
                    @view-revit-comp="viewRevitComp"
                    @view-gcs-comp="viewGcsComp"
                    @view-web-comp="viewWebComp"
                    @place-revit-comp="placeRevitComp"
                    @place-gcs-comp="placeGcsComp"
                    @place-cs-comp="placeCSComp"
                    @load-gcs-comp="loadGcsComp"
                />
              </div>
            </gjw-dimensions>
          </div>
          <div class="left-main-content" >
            <gjw-dimensions @height-changed="getCurvesContainerHeight">
              <template #default>
                <div class="curve-dimension-box">
                  <detail-split-box v-if="hasCurves" class="left-box" title="拟合曲线">
                    <component
                      :is="comp"
                      ref="curveChart"
                      :curves-width="616"
                      :curves-height="curvesHeight"
                      :refresh-speed-times="refreshSpeedTimes"
                      :performance-curve-data="curveData"
                      @refresh-curve-data="refreshCurveData"
                      @track-speed-regulated="onRegulatedTracked"/>
                  </detail-split-box>
                </div>
              </template>
            </gjw-dimensions>
            <div
              class="right-box"
              :class="{'right-box-verti':hasCurves||pageLoading,'right-box-horiz':!(hasCurves||allowRelateSources||pageLoading)}"
              :style="{'height':hasCurves?`${curvesContainerHeight}px`:'auto'}">
              <div class="right-part-two box-border" :class="{'right-part-two-margin':!hasCurves}">
                <gjw-tabs :tabs="dataTabs" class="full-height" @contentSizeChanged="getDataTabsHeight">
                  <template #content-curveData>
                    <!--性能数据-->
                    <div class="data-tab-container full-height" >
                      <div class="curve-table">
                          <el-table :data="performancePropData" width="100%" :max-height="tableHeight" class="center-table">
                            <el-table-column align="center" label="末端风速(m/s)" prop="speed" min-width="55px" :formatter="formatValue" />
                            <el-table-column align="center" label="工况序号" prop="index" min-width="60px" />
                            <el-table-column
                                v-for="(header,i) in performancePropHeader"
                                :key="i"
                                align="center"
                                :label="`${header.name}(${header.unitSymbol})`"
                                :prop="header.code"
                                :formatter="formatValue"
                            />
                          </el-table>
                        </div>
                    </div>
                  </template>
                  <template #content-productData>
                    <!--产品参数内容-->
                    <div class="data-tab-container full-height">
                      <detail-properties-box :properties="parameters">
                        <template #groupContent="{group}">
                          <el-row class="group-content">
                            <el-col
                                :span="!hasCurves && allowRelateSources ? 8 : 12"
                                v-for="(property,x) in group.parameterValues"
                                :key="x"
                            >
                              <div v-if="property.showValue" class="property flex-container">
                                <span class="property-name line-no-wrap" :title="property.name">{{ property.name }}</span>
                                <span class="property-value line-no-wrap" :title="property.showValue">
                                  {{ property.showValue }}
                                  <span v-if="property.isCalculated">
                                    <el-tooltip v-if="property.name==='中档全冷'||property.name==='中档显冷'||property.name==='中档制热'||property.name==='低档全冷'||property.name==='低档显冷'||property.name==='低档制热'" class="item" effect="dark" content="根据经验公式估值，仅供参考" placement="top">
                                      <i class="el-icon-warning"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="property.name==='中档潜冷'||property.name==='低档潜冷'||property.name==='高档潜冷'||property.name==='低档制冷热湿比'||property.name==='中档制冷热湿比'||property.name==='高档制冷热湿比'" class="item" effect="dark" content="根据全热冷量和显热冷量计算得出" placement="top">
                                      <i class="el-icon-warning"></i>
                                    </el-tooltip>
                                  </span>
                                </span>
                              </div>
                            </el-col>
                          </el-row>
                        </template>
                      </detail-properties-box>
                    </div>
                  </template>
                </gjw-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </gjw-dimensions>
    <div class="page-right" v-if="showPrice" :style="{'height':`${mainHeight}px`}">
      <Search ref="goodsSearch" @close-search="showPrice=false" class="search" :track-info="trackInfo"  />
    </div>
    <component-drawer
        ref="componentDetail"
        :show-place-button="false"
        @load-g-component="loadGcsComp"
        @place-g-component="placeGcsComp"
        @place-cs-component="placeCSComp"
        @place-r-component="placeRevitComp"
    />
    <web-download-component />
    </div>
</template>

<script>
import Search from '@/components/business/goods/Search.vue'
import productDetailMixin from '@/mixins/productDetailMixin'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BackHeader from '@/components/business/BackHeader'
import DetailSplitBox from './components/DetailSplitBox'
import DetailPropertiesBox from './components/DetailPropertiesBox'
import GjwTabs from '@/components/lib/GjwTabs'
import ComponentDrawer from './components/ComponentDrawer'
import WebDownloadComponent from '@/components/business/WebDownloadComponent.vue'
import SourceList from './components/SourceList.vue'
import FanCurve from './components/FanCurve.vue'
import PumpCurve from './components/PumpCurve.vue'
import GjwDimensions from '@/components/lib/GjwDimensions.vue'
import { GetProductPriceEnquiryHint } from '@/core/gcsUtils'
import goodsSearchMixin from '@/mixins/goodsSearchMixin'
import gcsReplayRecordMixin from '@/mixins/gcsReplayRecordMixin'
import NavShopBasket from '@/components/business/NavShopBasket'

export default {
  props: {
    productIds: {
      type: [Number, String],
      default: null
    },
  },
  name: 'ProductDetail',
  mixins: [productDetailMixin, goodsSearchMixin, gcsReplayRecordMixin],
  components: {
    Search,
    BackHeader,
    DetailSplitBox,
    DetailPropertiesBox,
    GjwTabs,
    ComponentDrawer,
    WebDownloadComponent,
    SourceList,
    FanCurve,
    PumpCurve,
    GjwDimensions,
    NavShopBasket
  },
  data() {
    return {
      pageLoading: false, // 让页面样式初始展示的时候按照默认样式
      productId: Number(this.$route.params.id),
      imageUrlFailed: false,
      showDrawer: false,
      tableHeight: 320,
      refreshSpeedTimes: 0,
      showPrice: false,
      // 保证flex左右高度相同
      mainHeight: null,
      // 头部产品图片宽度需要跟右侧高度一致
      headerRightHeight: null,
      curvesContainerHeight: null,
      trackInfo: {}
    }
  },
  provide() {
    return {
      speedType: this.getSpeedType
    }
  },
  computed: {
    ...mapGetters({
      detail: 'productDetail/detail',
      category: 'productDetail/category',
      hasCurves: 'productDetail/hasFormula', // 拟合公式
      parameters: 'productDetail/parameters', // 产品参数
      performanceData: 'productDetail/performanceData', // 性能数据
      curveData: 'productDetail/curveData', // 拟合曲线数据
      performanceHeaderX: 'productDetail/performanceHeaderX',
      performanceHeaderYs: 'productDetail/performanceHeaderYs',
      needData: 'productDetail/needData',
      powerConsumptionPerAirVolume: 'productDetail/powerConsumptionPerAirVolume',
      performancePropHeader: 'productDetail/performancePropHeader',
      performancePropData: 'productDetail/performancePropData',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      propertyDefinition: 'goods/propertyDefinition',
      brandCode: 'brandCode', // 临时添加凯泉水泵独立页面
      goodsProperties: 'productDetail/goodsProperties',
      originWorkCondition: 'productDetail/originWorkCondition',
      productClassifications: 'classification/productClassifications',
      isFluidMeterUnit: 'productDetail/isFluidMeterUnit'
    }),
    isFanOrPump() {
      return this.category === 'fan' || this.category === 'pump' || this.category === 'outlet' || this.category === 'VFWaterSupply'
    },
    comp() {
      return this.category === 'pump' ? 'PumpCurve' : 'FanCurve'
    },
    productImage() {
      return this.detail.imageUrl && !this.imageUrlFailed ? this.detail.imageUrl : require('@/assets/image/default_product_img.png')
    },
    dataTabs() {
      return this.performancePropData.length ? [{ id: 'productData', name: '产品参数' }, { id: 'curveData', name: '性能数据' }] : [{ id: 'productData', name: '产品参数' }]
    },
    selectedProductDesignProperties() {
      const queryDesignProps = this.$route.query.designProperties
      /** getDesignProperties暂时不处理query中没有designProperties这种情况
       * 风机水泵没有搜索条件给过来的值是空
       * 基础选型没有搜索条件给过来的值是额定值
       * */
      return queryDesignProps ? JSON.parse(queryDesignProps) : this.getDesignProperties()
    },
    curvesHeight() {
      return this.curveData.yAxises && this.curveData.yAxises.length > 3 ? 944 : 600
    },
    allowRelateSources() {
      const platClassify = this.productClassifications
      const code = this.detail.gjwCategoryCode
      if (Array.isArray(platClassify)) {
        const specClassify = platClassify.find((c) => c.code === code)
        if (specClassify) {
          const configItemValues = specClassify.configItemValues || []
          const item = configItemValues.find((values) => values.code === 'isCanRelateResources')
          return !!item && item.value === 'true'
        }
      }
      return false
    },
    searchedWithCurveData() {
      const properties = this.selectedProductDesignProperties
      return properties && properties.length && properties.some((p) => p.values !== null)
    },
  },
  async created() {
    // 清空detail的数据 防止缓存
    try {
      // this.setProductId(localStorage.getItem('getProductId'))
      this.loadUserInfo()
      this.pageLoading = true
      await this.loadDetail()
      this.loadRelatedComponents()
      this.loadRelatedBlocks()
      const isFluidMeterUnit = this.getIsFluidMeterUnit
      this.updateIsFluidMeterUnit(isFluidMeterUnit)
      this.loadProperties().catch()
      if (this.isFanOrPump) {
        if (this.category !== 'outlet') {
          await this.loadCurveData() // 基础选型不包含性能数据处理
        }
        await this.loadPerformanceProperties()
      }
      await this.loadProductClassifications()
      if (this.allowRelateSources) {
        await Promise.all([
          this.loadRelatedComponents(),
          this.loadRelatedBlocks()
        ])
      }
      if (this.isFanOrPump) {
        const chartNeedPoints = this.formatDesignData(this.selectedProductDesignProperties)
        this.setNeedData(chartNeedPoints)
        await this.refreshCurveData(null, true)
        // 确保图表DOM更新后，再初始化图表，防止图表无法init
        setTimeout(() => {
          const performanceCurve = this.$refs.curveChart
          performanceCurve && performanceCurve.init()
        }, 0)
      }
      if (!this.isFanOrPump && !this.$route.query.designProperties) {
        this.handleDefaultDesignProps(this.detail.gjwCategoryCode)
      }
      if (this.platform === 'r') {
        this.loadDefinitions({ gjw_category_code: this.detail.gjwCategoryCode }).catch()
      }
    } catch (err) {
      console.error(err)
    } finally {
      this.pageLoading = false
    }
  },
  mounted() {
    // 进入详情页，返回actionResult，结束回放
    window.replayProductDetailCallback && window.replayProductDetailCallback()
    this.loadProperties()
    this.platform === 'g' && this.setPropertyDefinition([])
  },
  beforeDestroy() {
    this.setDetail({})
    this.setPerformance([])
  },
  methods: {
    ...mapMutations({
      setProductId: 'productDetail/setProductId',
      setDetail: 'productDetail/setDetail',
      setPerformance: 'productDetail/setPerformance',
      setNeedData: 'productDetail/setNeedData',
      setPropertyDefinition: 'goods/setPropertyDefinition',
      updateIsFluidMeterUnit: 'productDetail/updateIsFluidMeterUnit'
    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      loadDetail: 'productDetail/loadDetail',
      loadDefinitions: 'shareParams/loadDefinitions',
      loadProperties: 'productDetail/loadProperties',
      loadCurveData: 'productDetail/loadCurveData',
      loadOperatingData: 'productDetail/loadOperatingData',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
      loadPerformanceProperties: 'productDetail/loadPerformanceProperties',
      loadProductClassifications: 'classification/loadProductClassifications'
    }),
    getSpeedType() {
      return this.speedType
    },
    getDataTabsHeight(obj) {
      const heightNumber = obj.newValue - 1
      this.tableHeight = heightNumber.toFixed(0)
    },
    getMainHeight(obj) {
      this.mainHeight = obj.newValue
    },
    getHeaderRightHeight(obj) {
      this.headerRightHeight = obj.newValue || 104
    },
    getCurvesContainerHeight(obj) {
      this.curvesContainerHeight = obj.newValue
    },
    // 处理需求点，使其符合图表所需的数据格式
    formatDesignData(designProperties) {
      const results = []
      designProperties.forEach((item) => {
        const name = item.name.slice(2)
        if (item.codes.includes('/')) {
          const codes = item.codes.split('/')
          const values = item.values ? item.values.split('/') : [null, null]
          results.push(
            {
              code: codes[0],
              label: `高速${name}(${item.unit})`,
              value: values[0] || values[0] === 0 ? values[0] : null,
              sort: 0
            }, {
              code: codes[1],
              label: `低速${name}(${item.unit})`,
              value: values[1] || values[1] === 0 ? values[1] : null,
              sort: 1
            }
          )
        } else {
          results.push({
            code: item.codes,
            label: `${name}(${item.unit})`,
            value: item.values,
            sort: 0
          })
        }
      })
      return results.length ? results.sort((a, b) => { return a.sort - b.sort }) : []
    },
    // 刷新运行点，整理新的curveData
    async refreshCurveData(rate, first) {
      // 有拟合公式的产品，才请求
      if (this.hasCurves && this.searchedWithCurveData) {
        await this.loadOperatingData({ rate, needPoints: this.needData, first })
        !first && this.refreshSpeedTimes++
      }
    },
    async getPrice() {
      const isLogin = await this.checkLogin()
      if (isLogin) {
        this.trackInfo = {
          eventName: 'productPriceQuery',
          itemEventName: 'contactPriceSupplier',
          categoryName: this.detail.gjwCategoryName,
          g_c_product_id: this.detail.id
        }
        const hasPropertyDefinition = Boolean(this.propertyDefinition.length)
        // 缓存当前产品的属性定义
        if (!hasPropertyDefinition) {
          await this.loadPropertyDefinition(this.detail.gjwCategoryCode)
        }
        await this.loadAreas()
        const res = await GetProductPriceEnquiryHint()
        const { areaName } = res.data || {}
        const condition = {
          areaName,
          brandName: this.detail.brandName,
          productModel: this.detail.model,
          categoryCode: this.detail.gjwCategoryCode,
          name: this.detail.name,
          softwareCode: this.softwareCode,
          softwareVersion: this.softwareVersion,
          type: 'PRODUCT',
          propertyValues: this.goodsProperties,
          platform: this.platform
        }
        this.showPrice = true
        this.$nextTick(() => {
          this.readyGoodsSearch(condition)
        })
      }
    },
    onRegulatedTracked() {
      this.$tracks({
        event: 'speedRegulation',
        params: {
          g_c_product_id: this.detail.id,
          g_c_product_model: this.detail.model
        }
      })
    },
    formatValue(row, col) {
      return this.$fmtValue(row[col.property], '-')
    }
  },
}
</script>

<style lang="less" scoped>
/deep/.el-icon-warning{
  color:#4897F5
}
/deep/.el-collapse-item__content{
    padding-bottom: 0;
  }
 /deep/.el-collapse-item__wrap{
    border-bottom: unset;
    padding-bottom:1rem;
  }
  /deep/.el-collapse-item__header{
    font-size: 1rem;
    padding: 0 12px;
    background-color: @bg-grey-dark;
    height: 32px;line-height: 32px;
  }
  /deep/.el-image{
    .image-slot{
      width: 100%;
      height: 100%;
      display: flex;
    }
  }
.product-detail{
  box-sizing: border-box;
  width: 100%;
  flex-grow: 1;
  overflow-x: hidden;
}

.page-left{
  flex-grow: 1;
  overflow-x: auto;
  padding: 0 24px 24px;
  .page-left-wrapper{
    // min-width: 1200px;
  }
}
.page-right{
  border-left: 1px solid @theme-border-color;
  position:relative;
  min-width:560px;
  .search{
    position:absolute;
    width:100%;
    height:100%;
    z-index: 10;
  }
}
.header{
  margin-bottom: 10px;
  .header-left{
    min-width: 104px;
    max-width: 248px;
    max-height: 248px;
    border: 1px solid @theme-border-color;
    .img-tab-container{
      height: 100%;
      align-items: center;
    }
    .product-img{
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .header-right{
    flex: 1;
    margin-left: 10px;
  }
  .header-right-info{
    flex: 1;
  }
  .model{
    font-size: 1.2857rem;
    margin-bottom: 8px;
    color: @theme-grey-1;
  }
  .meta{
    margin-right: 24px;
    color: @theme-text-secondary;
  }
}
.left-main-content{
  position: relative;
  display: flex;
  flex-direction: row;
  padding-bottom: 1rem;
}
// 隐藏曲线
.curve-dimension-box{
  // display:none;
  height: max-content;
}
.left-box{
  flex: 0 0 640px;
  width: 640px;
  margin-right: 20px;
  min-height:700px;
}
.right-box {
  height: auto;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  .right-part-one{
    flex: 0 0 320px;
    display: flex;
    flex-direction: row;
    height: 320px;
    margin-bottom: 20px;
  }
  .right-part-two{
    flex: 1;
    height: calc(100% - 340px);
    position: relative;
    &.right-part-two-margin{
      margin-bottom: 20px;
    }
  }
  .images-container{
    flex: 1;
    min-width: 240px;
  }
  .related-box{
    flex: 1;
    margin-left: 10px;
  }
  .curve-table{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .data-tab-container{
    position: relative;
    min-height: 310px;
  }
  .product-img,.curve-thumbnail{
    max-width: 240px;
    max-height: 240px;
    object-fit: contain;
  }
  .source-list-container{
    height: 100%;
  }
  .related-tab-container{
    width: 100%;
    max-height: 166px;
    padding-bottom: 1rem;
    overflow: auto;
  }

  &.right-box-verti{
    width: calc(100% - 660px);
  }
  &.right-box-horiz{
    width: 100%;
    display: flex;
    flex-direction: row;
    .right-part-one{
      flex: 0 0 640px;
      margin-right: 20px;
      height: 680px;
    }
    .right-part-two{
      min-height: 358px;
    }
    .img-tab-container{
      height: 100%;
      padding: 190px 0;
      align-items: center;
    }
    .product-img,.curve-thumbnail{
      max-width: 256px;
      max-height: 256px;
      object-fit: contain;
    }

  }
}
.group-content{
  .property{
    font-size: 1rem;
    margin-top: .5714rem;
    .property-name{
      text-align: right;
      padding-right:1.1429rem;
      color: @theme-grey-3;
      width: 40%;
      flex: 0 0 auto;
    }
    .property-value{
      flex-grow: 1;
      text-align: left;
      color: @theme-grey-1;
    }
  }
}
/deep/.tabs-content{
  overflow: inherit !important;
  border: 1px solid #ccc !important
}
.navShopBasket{
  position: absolute;
  top: 0;
  right: 0;
  width: 128px;
}
</style>
